import axios from "axios";

// export const authAPI = axios.create({
//   baseURL: 'https://tyhdym3zijlcj7yuhadwnvtlnm0cjtgm.lambda-url.us-east-1.on.aws',
// });

export const authAPI = axios.create({
  baseURL: 'https://api.reasoner.alpha.sofya.ai/v1/sdk',
});

export const authService = async (apiKey: string) => {
  try {
    const { data } = await authAPI("/providers", {
      method: 'get',
      headers: {
        'x-api-key': apiKey,
      },
    })
    return data
  } catch {
    console.error("Unable to authenticate. Please check your api key");
    return undefined;
  }
};
